module.exports = __webpack_public_path__ + "static/media/craft-01.f610b5e8.svg";